import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { fetchTraits, fetchStudentTraits, updateStudentTraits, clearUpdatedStudentTraits } from '../../../store/actions/traitsActions'
import Loader from '../../elements/Loader';
import ModalActionButton from '../../elements/ModalActionButton';
import NumberField from '../../elements/form/NumberField';

const ManageStudentTraits = ({ student, close, reload }) => {
    const dispatch = useDispatch()
    const traitsSelector = useSelector(state => state.traits) 
    const [studentTraits, setStudentTraits] = useState([])

    useEffect(() => {
        dispatch(fetchTraits('', 0, 0))
        dispatch(fetchStudentTraits(`student=${student._id}`)) 
        
        return () => {
            
        };
    }, [dispatch, student._id]);

    useEffect(() => {
        const fetchedTraits = traitsSelector?.studentTraits?.studentTraits?.[0]?.traits

        setStudentTraits(fetchedTraits?.length
            ? fetchedTraits.map(({ trait, score }) => ({
                trait: typeof trait === 'object' ? trait._id : trait,
                score
            }))
            : []
        )
    }, [traitsSelector?.studentTraits?.studentTraits])

    const findStudentTraitScore = (traitId) => {
        
        const studentTrait = traitsSelector?.studentTraits?.studentTraits[0]?.traits?.find(t => t.trait._id === traitId);
        return studentTrait ? studentTrait.score : '';
    }

    const updateTraitScore = (traitId, score) => {
        setStudentTraits(currentTraits => {
            const traitExists = currentTraits.some(trait => trait.trait === traitId)

            if (traitExists) {
                return currentTraits.map(trait => trait.trait === traitId
                    ? { ...trait, score }
                    : trait
                )
            }

            return [...currentTraits, { trait: traitId, score }]
        })
    }

    const [validationErrors, setValidationErrors] = useState({})

    const validateForm = () => {
        const errors = {}
        if(studentTraits.length === 0) {
            return false;
        }
        studentTraits.forEach(trait => {
            if(trait.score > 10) {
                errors[trait.trait] = 'Score cannot be greater than 10';
            }
            if(trait.score < 0) {
                errors[trait.trait] = 'Score cannot be less than 0';
            }
        });
        setValidationErrors(errors)
        console.log(errors)
        return Object.keys(errors).length === 0;
    }

    const pushTraits = () => {
        if(!validateForm()) {
            return;
        }
        dispatch(updateStudentTraits({
            student: student._id, 
            traits: studentTraits}
        ))
    }

    useEffect(() => {
        if(traitsSelector?.updatedStudentTraits) {
            dispatch(clearUpdatedStudentTraits())
            reload()
            close()
        }
        return () => {
            
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, traitsSelector?.updatedStudentTraits]);

    return (
        <div className="w-full">
            <p className="text-gray-600 text-sm mb-4">Manage traits for this student. Add a score for each trait below.</p>
            {traitsSelector?.loadingTraits || traitsSelector?.loadingStudentTraits ? (
                <Loader />
            ) : (
                <div className="w-full">
                    {traitsSelector?.traits?.traits?.map((trait, index) => (
                        <div key={index} className="flex items-center justify-between transition duration-200 gap-x-4 py-2 pl-4 pr-2 rounded border border-gray-200 focus-within:border-gray-300 focus-within:shadow-lg focus-within:shadow-black/5 mb-4">
                            <div className="w-full">
                                <p className="text-gray-700 text-[14px]">{trait.name}</p>
                                {validationErrors[trait._id] && <p className="text-[10px] text-red-600">{validationErrors[trait._id]}</p>}
                            </div>
                            <div className="w-full relative">
                                
                                <NumberField 
                                    inputLabel={``} 
                                    fieldId={`trait-${trait._id}`} 
                                    hasError={validationErrors[trait._id] ? true : false} 
                                    returnFieldValue={(value) => updateTraitScore(trait._id, value)} 
                                    preloadValue={findStudentTraitScore(trait._id) || ''} 
                                    inputPlaceholder={`Enter score for ${trait.name}`}
                                    maxLength={2}
                                    requiredField={true}
                                />
                            </div>
                        </div>
                    ))}
                </div>
            )}

            <div className="mt-8 flex flex-row-reverse gap-x-4">
                <ModalActionButton
                    buttonLabel={`Update Student Traits`}
                    buttonAction={pushTraits}
                    processing={traitsSelector?.updatingStudentTraits}
                />

                <button
                    type="button"
                    className="inline-flex justify-center px-5 py-4 text-xs font-medium bg-transparent border border-transparent rounded-md hover:bg-opacity-50 hover:bg-secondary focus:outline-none"
                    onClick={close}
                >
                    Cancel
                </button>
                
            </div>
        </div>
    )
}

export default ManageStudentTraits